import React from 'react';
import { CircleCheckBig, CircleX, Pen } from 'lucide-react';
import ExploreChangesButton from '../ExploreChangesButton/ExploreChangesButton';
import './style.css';

const DatapointChangeCard = ({ 
    change, 
    getTimelineLength,
    onExploreClick 
}) => {
    return (
        <div className="change-card">
            <div className="change-id">{change.name}</div>
            <div className="change-status">
                {change.status_type === 'completed' && <CircleCheckBig className="status-icon" />}
                {change.status_type === 'changed' && <Pen className="status-icon" />}
                {(change.status_type === 'incomplete' || change.status_type === 'removed') && <CircleX className="status-icon" />}
                {change.status}
            </div>
            <ExploreChangesButton
                timelineLength={getTimelineLength(change.type, change.id)}
                type={change.type}
                onClick={onExploreClick}
            />
        </div>
    );
};

export default DatapointChangeCard;
